import React, { useState, useEffect, forwardRef } from 'react'
import { useSelector } from 'react-redux'
import colors from 'components/pages/contacts/colors'
import { ContactsPageTypes } from 'common/Enums'
import { WebphoneModal, PageHeaderWithButtons } from 'components/shared'
import { useTranslation } from 'react-i18next'

export const ContactsList = forwardRef(
    (
        {
            contactsList,
            slug,
            toggleKeypad,
            backHandler = () => {},
            onContactClick = () => {},
            isHeaderVisible,
            addTransferInputValue
        },
        ref
    ) => {
        const [contactDetails, setContactDetails] = useState(null)
        const [isModalVisible, setModalVisible] = useState(false)
        const [isCheckedNumber, setIsCheckedNumber] = useState('')
        const calls = useSelector((state) => state.call.calls)
        const toggleModal = () => setModalVisible(!isModalVisible)

        useEffect(() => {
            setIsCheckedNumber(addTransferInputValue)
        }, [addTransferInputValue])

        const handleOnContactClick = (phoneNumber, userAvatar, userName, bgColor, textColor, isLocked) => {
            if (isLocked) {
                return
            }
            if (slug !== 'all') {
                onContactClick(phoneNumber)
            } else {
                toggleModal()
            }

            setContactDetails({
                phoneNumber,
                userAvatar,
                userName,
                bgColor,
                textColor
            })
        }

        const modalData = {
            imgSrc: contactDetails?.userAvatar,
            text: contactDetails?.userName,
            phoneNumber: contactDetails?.phoneNumber,
            customContent: () =>
                renderPhoneColorBlock(contactDetails?.bgColor, contactDetails?.textColor, contactDetails?.phoneNumber)
        }

        const renderPhoneColorBlock = (bgColor, textColor, phoneNumber) => (
            <div className="contacts__item__number-wrp">
                <span className="contacts__item__number" style={{ color: textColor, backgroundColor: bgColor }}>
                    {phoneNumber}
                </span>
            </div>
        )

        function renderContactItem(item, index) {
            const { extension_uuid, extension, effective_caller_id_name } = item

            let isLocked = false
            if (calls.length) {
                const currentCallNumber = calls.filter((item) => item.number === extension)

                if (currentCallNumber.length) {
                    isLocked = true
                }
            }

            let colorIndex = index
            const colorsLength = colors.length
            if (index > colors.length - 1) {
                colorIndex = index - Math.floor(index / colorsLength) * colorsLength
            }
            const bgColor = colors[colorIndex]?.bgColor
            const textColor = colors[colorIndex]?.textColor
            const userAvatar = '/images/recents/user_avatar.svg'
            return (
                <div
                    key={extension_uuid}
                    className={`${
                        isLocked === true || isCheckedNumber === extension
                            ? 'contacts__item locked-contact'
                            : 'contacts__item'
                    } d-flex align-items-center`}
                    onClick={() =>
                        handleOnContactClick(
                            extension,
                            userAvatar,
                            effective_caller_id_name,
                            bgColor,
                            textColor,
                            isLocked
                        )
                    }
                >
                    {renderPhoneColorBlock(bgColor, textColor, extension)}
                    <span className={`contacts__item__name ${!effective_caller_id_name ? 'unassigned' : ''}`}>
                        {effective_caller_id_name || `(${t('unassigned')})`}
                    </span>
                </div>
            )
        }

        const { t } = useTranslation()

        return (
            <div className="contacts" ref={ref}>
                {isHeaderVisible &&
                    (slug !== ContactsPageTypes.AllContacts ? (
                        <PageHeaderWithButtons
                            pageName={slug === ContactsPageTypes.TransferCall ? t('transfer_call') : t('add_call')}
                            toggleKeypad={toggleKeypad}
                            backHandler={backHandler}
                        />
                    ) : null)}
                {contactsList.map((item, index) => renderContactItem(item, index))}
                <WebphoneModal {...{ isModalVisible, toggleModal, modalData, slug, backHandler }} />
            </div>
        )
    }
)
